import styles from './styles.module.scss';

const TabLabel = ({ label, count }) => (
  <div className={styles.tabLabelContainer}>
    <span>{label}</span>
    {/* <div className={styles.tabLabelCount}>{count}</div> */}
  </div>
);

export default TabLabel;
